import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import { UseBoundStore } from 'zustand';

import { PersistMethods } from './types/PersistMethods';

/**
 * Checks if a Zustand store instance includes the `persist` middleware.
 */
export const hasPersist = (
  store: UseBoundStore<any>,
): store is { persist: PersistMethods } => {
  return isFunction(get(store, 'persist.clearStorage'));
};
